import styled from 'styled-components';
import { Text, color, media } from '@morressier/ts';

interface StyleProp {
  bkgColor: string;
  foregroundColor?: string;
}

export const ProductCardBase = styled.div`
  background-color: ${color('white')};
  border-radius: 1rem;
  display: block;
  text-decoration: none;
  overflow: hidden;
  border: 1px solid var(--color-mono-90);

  main {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1.5rem;
    height: calc(100% - 12rem);
  }
`;

export const ProductCardBanner = styled.div<{ img: string }>`
  display: flex;
  justify-content: center;
  height: 12rem;
  background-image: ${({ img }) => `url(${img})`};
  background-size: cover;
  background-position: 50% 0%;
`;

export const ProductCardTitle = styled(Text).attrs({
  textAs: 'div',
  size: 'h5_new'
})`
  font-size: var(--fontSizes-m);
  line-height: var(--lineHeights-m);
  font-weight: bold;
  color: var(--color-mono-0);
  overflow: hidden;
  text-align: center;
  display: flex;

  .chip {
    background: var(--color-mono-0);
    border-radius: 4px;
    padding-left: 4px;
    padding-right: 4px;
    color: var(--color-mono-100);
    font-size: var(--fontSizes-s);
    font-weight: 500;
    margin-left: 8px;
  }
`;

export const ProductCardDescription = styled(Text).attrs({
  textAs: 'div',
  size: 'body1_new'
})`
  color: var(--color-mono-40);
  margin: 0.5rem auto 1rem auto;
  text-align: center;
  strong {
    font-weight: bold;
  }
`;

export const ProductCardCTAWrapper = styled.div<StyleProp>`
  margin: auto;
  margin-bottom: 0;
  a,
  button {
    background: ${({ bkgColor }) => bkgColor};
    color: ${({ foregroundColor }) => foregroundColor};
  }
  .icon {
    font-size: 20px;
  }
`;
